module.exports = __webpack_public_path__ + "media/configurations/SV_O-X-X-X-X-O-a608b3d6.png";